// React.
import React from 'react';

// Material UI.
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

// Components.
import ActionAlert from '../admin/utils/ActionAlert';
import ValidateAccountForm from './ValidateAccountForm';
import Logo from '../client/utils/Logo';
import logoImg from '../../alt-logo-1.png';

// Styles.
import useStyles from './LoginStyles';

const ValidateAccount = () => {
  const classes = useStyles();

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="sm">
        <ActionAlert />
        <div className={ classes.logo }>
          <Logo altLogo={logoImg}/>
        </div>
        <Paper elevation={3} square={false} variant="elevation">
          <ValidateAccountForm />
        </Paper>
      </Container>
    </div>
  )
}

export default ValidateAccount;
